import React, {useState} from 'react';
import PropTypes from 'prop-types';
import apiHelper from 'helpers/api-helper';
import './brainstorm-simple-facilitator.scss';

const BrainstormSimpleFacilitator = ({minigameData, gameId, minigameGameData}) => {
	const [isUpdatingMinigame, setIsUpdatingMinigame] = useState(false);

	/**
	 * Remove group submission
	 * @param {number} submissionIndex 
	 * @returns 
	 */
	const removeSubmission = (submissionIndex) => {
		if (isUpdatingMinigame) return;
		setIsUpdatingMinigame(true);
		apiHelper('facilitator/remove-minigame-submission', {
			gameId,
			minigameId: minigameData.id,
			submissionIndex
		}).then(
			(response)=>{
				if (response.status === 'success') {
					setIsUpdatingMinigame(false);
				} else {
					console.error(response);
					setIsUpdatingMinigame(false);
				}
			},
			(error) => {
				console.error(error);
				setIsUpdatingMinigame(false);
			}
		);
	};

	return (
		<div className={'BrainstormSimpleFacilitator ' + minigameData.id}>
			{/* Part 1 */}
			<div className="BrainstormSimpleFacilitator-part1">
				{/* Submissions */}
				<div className="BrainstormSimpleFacilitator-submissions">
					{(minigameGameData && minigameGameData.submissions) && 
							minigameGameData.submissions.map((submission, index) => {
								return (
									<div 
										key={index} 
										className="BrainstormSimpleFacilitator-submission"
									>
										<span>{submission.value}</span>
										<div 
											className="BrainstormSimpleFacilitator-removeSubmissionBtn" 
											onClick={() => {removeSubmission(index);}}
										/>
									</div>
								);
								
							})
					}
				</div>
			</div>


		</div>
	);
};

BrainstormSimpleFacilitator.propTypes = {
	minigameData: PropTypes.object.isRequired,
	gameId: PropTypes.string.isRequired,
	minigameGameData: PropTypes.object,
};

export default BrainstormSimpleFacilitator;
